import React from 'react';
import { useNavigate } from 'react-router-dom';
import { motion } from 'framer-motion';
import './PaymentSystem.css';

/**
 * PaymentCancel - 2025 Empathetic Design
 *
 * No guilt, no pressure. Just helpful options.
 * Cash App principle: respect the user's decision
 */
const PaymentCancel = () => {
  const navigate = useNavigate();

  return (
    <div className="payment-page">
      <motion.div
        className="cancel-card"
        initial={{ opacity: 0, y: 20 }}
        animate={{ opacity: 1, y: 0 }}
        transition={{ duration: 0.4 }}
      >
        <motion.div
          className="cancel-icon"
          initial={{ scale: 0.8 }}
          animate={{ scale: 1 }}
          transition={{ delay: 0.1 }}
        >
          👋
        </motion.div>

        <motion.h1
          className="cancel-title"
          initial={{ opacity: 0, y: 10 }}
          animate={{ opacity: 1, y: 0 }}
          transition={{ delay: 0.2 }}
        >
          No problem!
        </motion.h1>

        <motion.p
          className="cancel-subtitle"
          initial={{ opacity: 0, y: 10 }}
          animate={{ opacity: 1, y: 0 }}
          transition={{ delay: 0.3 }}
        >
          Your payment was cancelled and you weren't charged.
          <br />
          Take your time — we'll be here when you're ready.
        </motion.p>

        <motion.div
          initial={{ opacity: 0, y: 10 }}
          animate={{ opacity: 1, y: 0 }}
          transition={{ delay: 0.4 }}
          style={{ width: '100%' }}
        >
          <button
            className="cancel-cta"
            onClick={() => navigate('/pricing')}
          >
            View plans again
          </button>

          <button
            className="cancel-secondary"
            onClick={() => navigate('/')}
          >
            Return home
          </button>
        </motion.div>

        <motion.p
          initial={{ opacity: 0 }}
          animate={{ opacity: 1 }}
          transition={{ delay: 0.5 }}
          style={{
            fontSize: '14px',
            color: 'var(--color-text-tertiary, #a1a1aa)',
            marginTop: '24px',
            lineHeight: 1.5
          }}
        >
          Questions? Email us at{' '}
          <a
            href="mailto:care@teachtappy.com"
            style={{ color: 'var(--color-primary, #297A92)' }}
          >
            care@teachtappy.com
          </a>
        </motion.p>
      </motion.div>
    </div>
  );
};

export default PaymentCancel;
